export { default as CustomerSummary } from "./CustomerSummaryV2";
